import Icon from 'veui/components/Icon'

Icon.register({
  'to-bottom': {
    paths: [
      {
        d: 'M128 704a32 32 0 0032 32h448a32 32 0 000-64H160a32 32 0 00-32 32zm502.76-330.24L406.63 597.9a32 32 0 01-45.26 0L137.24 373.76a32 32 0 0145.25-45.25L352 498V64a32 32 0 0164 0v434l169.51-169.49a32 32 0 0145.25 45.25z'
      }
    ],
    width: '768',
    height: '768'
  }
})
